module.exports = __webpack_public_path__ + "img/OverseaMember27.9c28ed0f.jpg";